import React from "react";

const Playhead = ({
	playheadX,
	sharedScrollLeft,
	handlePlayheadMouseDown,
	sharedScrollContainerRef,
	pasteTargetPulseKey = 0,
}) => {
	const container = sharedScrollContainerRef.current;
	const visibleWidth = container?.clientWidth || 0;
	
	// Get the actual track area width from  DOM 
	const getActualTrackAreaWidth = () => {
		
		const trackAreaElement = document.querySelector('.w-\\[14\\%\\].min-w-\\[220px\\]');
		if (trackAreaElement) {
			return trackAreaElement.offsetWidth;
		}
		
		return Math.max(window.innerWidth * 0.14, 220);
	};
	
	const trackAreaWidth = getActualTrackAreaWidth();
	
	// Position the cursor relative to the grid area start
	const clampedX = Math.min(Math.max(0, playheadX - sharedScrollLeft), visibleWidth);

	return (
		<div
			className={[
				'annotation-playhead',
				playheadX < sharedScrollLeft || playheadX > sharedScrollLeft + visibleWidth
					? 'invisible'
					: '',
				pasteTargetPulseKey > 0 ? 'annotation-playhead--paste-target' : '',
			].filter(Boolean).join(' ')}
			style={{
				position: "absolute",
				top: 0,
				left: `${trackAreaWidth}px`, // Use calculated track area width instead of percentage
				width: `calc(100% - ${trackAreaWidth}px)`, // Take remaining width
				height: "100%",
				pointerEvents: "none",
				zIndex: 1202, // Above the sticky ruler and its controls
			}}
		>
			<React.Fragment key={pasteTargetPulseKey}>
				{/* Triangle pointer at the top */}
				<div
					className="annotation-playhead-marker"
					style={{
						position: "absolute",
						left: `${clampedX}px`,
						top: 16,
						width: 0,
						height: 0,
						borderLeft: "10px solid transparent",
						borderRight: "10px solid transparent",
						borderTop: "14px solid #e63946",
						transform: "translateX(-50%)",
						zIndex: 1001,
						cursor: "grab",
						pointerEvents: "auto",
					}}
					onMouseDown={handlePlayheadMouseDown}
				/>

				{/* Vertical Line that extends through all content */}
				<div
					className="annotation-playhead-line"
					style={{
						position: "absolute",
						top: 30,
						left: `${clampedX}px`,
						width: "2px",
						height: "calc(100% - 30px)", // Extends to full container height minus triangle/handle area
						backgroundColor: "#e63946",
						pointerEvents: "auto",
						cursor: "grab",
						zIndex: 1000,
						transform: "translateX(-50%)",
					}}
					onMouseDown={handlePlayheadMouseDown}
				/>
			</React.Fragment>
		</div>
	);
};

export default Playhead;
